import type { CSSProperties } from 'react';
import { ImageSource } from '../../../imageSource/ImageSource';
import type { ImageSourceProps } from '../../../imageSource/ImageSource';
import { styles } from '../styles';

export const BannerImage = ({
  fullWidth = true,
  className = '',
  style,
  ...imageProps
}: Pick<ImageSourceProps, 'image' | 'imageAlt' | 'imageWebp' | 'imageMobile' | 'imageMobileWebp' | 'sizes'> & {
  fullWidth?: boolean;
  className?: string;
  style?: CSSProperties;
}) => (
  <div
    data-testid='ImageWrapper'
    className={`display-flex overflow-hidden border-bottom margin-bottom-xs palm-margin-bottom-s ${styles.imageWrapper} ${className}`}
    style={style}
  >
    <ImageSource
      {...imageProps}
      sizes={imageProps.sizes ?? '(min-width: 1014px) 1000px, 100vw'}
      pictureClassName='display-flex one-whole height-full'
      className='display-block one-whole height-full'
      style={{ objectFit: fullWidth ? 'cover' : 'contain' }}
    />
  </div>
);
